import { cn } from '@/lib/utils'

interface SelectionCardProps {
  label: string
  sublabel?: string
  onClick: () => void
  active?: boolean
}

export function SelectionCard({
  label,
  sublabel,
  onClick,
  active,
}: SelectionCardProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        'w-full rounded-2xl border-2 px-5 py-4 text-left transition-all active:scale-[0.98]',
        active
          ? 'border-primary bg-primary/10 shadow-md'
          : 'border-white/60 bg-white/80 shadow-xl backdrop-blur-md hover:bg-white/90',
      )}
    >
      <p className="text-base leading-tight font-semibold">{label}</p>
      {sublabel && (
        <p className="text-foreground/60 mt-0.5 text-sm">{sublabel}</p>
      )}
    </button>
  )
}
